import { RecoveryUserDTO } from "src/app/domain/recovery/dto/RecoveryUserDTO";
import { Rows } from "../../interfaces";
import { getHeaders } from "./headers";
import { left } from "../business-evaluation/mapping";
import { withCellStyles } from "../../utils";

export const getPreparedData = (users: RecoveryUserDTO[]): Rows => {
  const newData: Rows = [];
  newData.push(getHeaders());
  const userRows = getUsersRows(users);
  newData.push(...userRows);
  return newData;
};

const getUsersRows = (useusers: RecoveryUserDTO[]): Rows => {
  const rows: Rows = [];
  const headers = getHeaders();
  const mappedToHeaders = useusers.map((user) => getNewMapping(user));
  for (const mapped of mappedToHeaders) {
    const row = [];
    for (const header of headers) {
      row.push(withCellStyles(mapped[header], left));
    }
    rows.push(row);
  }
  return rows;
};

const getNewMapping = (user: RecoveryUserDTO): object => {
  return {
    'Profile': user.login,
    'FMS access': user.role,
    'Portal admin': user.portalAccess,
    '2FA - Disabled': user.isTestUser ? 'Yes' : 'No',
    'Joined': user.statistics.joined,
    'TOU & PP': cleanDate(user.profile.userTermsAndConditions.lastUpdateAgreement),
    'Last login': cleanDate(user.statistics.lastLogin),
    'Weekly': user.statistics.weeklyLogins,
    'Monthly': user.statistics.monthlyLogins,
    'Quarterly': user.statistics.quarterlyLogins,
    'Annual': user.statistics.annuallyLogins,
  };
};

const cleanDate = (date: Date): string => {
  if (date === null) {
    return '';
  }
  return new Date(date).toISOString().split('.')[0];
};
